export default "__VITE_ASSET__70965794__"